import serverCall from "../serverCall";

/**
 * Fetch all marketplaces from backend API
 */
const getMarketplaces = async () => {
  try {
    const response = await serverCall.get("/admin/marketplaces");
    return response;
  } catch (error) {
    throw error;
  }
};

/**
 * Add a new marketplace
 */
const addMarketplace = async ({ name, slug, hasFreeCredit = false, totalCredits = 0, freeCreditAmount = 1, credits }) => {
  const cleanSlug = slug.trim().toLowerCase();
  const cleanName = name.trim();
  const creditPool = Number(totalCredits ?? credits ?? 0);

  try {
    const response = await serverCall.post(
      `/admin/marketplaces`,
      {
        name: cleanName,
        slug: cleanSlug,
        hasFreeCredit: Boolean(hasFreeCredit),
        totalCredits: creditPool,
        credits: creditPool,
        freeCreditAmount: hasFreeCredit ? freeCreditAmount : 0,
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

/**
 * Update an existing marketplace
 */
const updateMarketplace = async (id, { name, slug, hasFreeCredit = false, totalCredits = 0, freeCreditAmount = 1, credits }) => {
  const cleanSlug = slug.trim().toLowerCase();
  const cleanName = name.trim();
  const creditPool = Number(totalCredits ?? credits ?? 0);

  try {
    const response = await serverCall.put(
      `/admin/marketplaces/${id}`,
      {
        name: cleanName,
        slug: cleanSlug,
        hasFreeCredit: Boolean(hasFreeCredit),
        totalCredits: creditPool,
        credits: creditPool,
        freeCreditAmount: hasFreeCredit ? freeCreditAmount : 0,
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

/**
 * Delete a marketplace
 */
const deleteMarketplace = async (id) => {
  try {
    const response = await serverCall.delete(`/admin/marketplaces/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const MarketplaceService = {
  getMarketplaces,
  addMarketplace,
  updateMarketplace,
  deleteMarketplace,
};

export default MarketplaceService;
